"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("./index");
const list_item_1 = require("./list-item");
class OrderedList extends index_1.TopLevelNode {
    constructor() {
        super(...arguments);
        this.content = new index_1.ContentNode('orderedList');
    }
    item() {
        return this.content.add(new list_item_1.ListItem());
    }
    textItem(text, marks) {
        this.item().paragraph().text(text, marks);
        return this;
    }
    linkItem(text, href, title) {
        this.item().paragraph().link(text, href, title);
        return this;
    }
    toJSON() {
        return this.content.toJSON();
    }
}
exports.OrderedList = OrderedList;
//# sourceMappingURL=ordered-list.js.map